import { render, staticRenderFns } from "./infoOtherRestaurants.vue?vue&type=template&id=47791a7c&scoped=true"
import script from "./infoOtherRestaurants.vue?vue&type=script&lang=js"
export * from "./infoOtherRestaurants.vue?vue&type=script&lang=js"
import style0 from "./infoOtherRestaurants.vue?vue&type=style&index=0&id=47791a7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47791a7c",
  null
  
)

export default component.exports